import { render, staticRenderFns } from "./People.vue?vue&type=template&id=cdc4068e&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"
import style0 from "./People.vue?vue&type=style&index=0&id=cdc4068e&prod&lang=scss&scoped=true"
import style1 from "./People.vue?vue&type=style&index=1&id=cdc4068e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc4068e",
  null
  
)

export default component.exports